import type { MotionProps } from 'framer-motion';
import {
  buildHiddenVariant,
  buildVisibleVariant,
} from '@/components/animations';

const Y_OFFSET = 30;

const hidden = buildHiddenVariant({ y: Y_OFFSET });
const visible = buildVisibleVariant();

export const wrapperMotionProps: MotionProps = {
  initial: 'hidden',
  whileInView: 'visible',
  viewport: { once: true },
};

export const contentMotionProps: MotionProps = {
  variants: {
    hidden,
    visible: buildVisibleVariant({
      transition: { staggerChildren: 0.15 },
    }),
  },
};

export const itemMotionProps: MotionProps = {
  variants: {
    hidden,
    visible,
  },
};

export const buttonMotionProps: MotionProps = {
  variants: {
    hidden,
    visible,
  },
  whileHover: { scale: 1.05 },
  whileTap: { scale: 0.95 },
};
